import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {PRIMER_SAVE_ORDER_FAILED_REASON} from 'constants/analytics/events/checkout';
import {PaymentInfoType} from 'types/PaymentMethodsType';

/**
 * send primer order error events
 */
export const sendPrimerOrderErrorEvents = (
    paymentInfo: PaymentInfoType,
    error: {error_code: string},
    responseStatus: number | string,
) => {
    sendDesktopAnalyticsEvent(PRIMER_SAVE_ORDER_FAILED_REASON, {
        errorCode: error.error_code,
        externalPaymentID: paymentInfo.token,
        orderId: paymentInfo.orderIncrementId,
        status: responseStatus,
    });
};
